<template>
  <div class="law">
    <div class="image-container" :class="{flip: flipStatus}">
      <!-- 示例图、空白框 -->
      <div class="img-list example" v-if="subtopicInfo.refer">
        <div class="img-item" :class="{isOptional: item.isOptional}" v-for="(item, index) in exampleImages" :key="index" @click="exampleClick(item,index)">
          <img v-if="item.img_url" :src="item.img_url" alt=""></img>
        </div>
      </div>
      <!-- 测试图片 -->
      <div class="img-list test">
        <div class="img-item" :class="{selected: getSelectedStatus(item)}" v-for="(item, index) in testImages" :key="index" @click="testSelect(item, index)">
          <img :src="item.img_url" alt=""></img>
        </div>
      </div>
    </div>
    <div class="flip-btn" @click="flip">
      <img src="@/assets/img/btn-flip.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: "law",
  props: {
    value: {
      type: [Number, String],
      default: ""
    },
    subtopicInfo: {
      type: Object,
      required: true
    },
    originalSubtopicInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      flipStatus: false,
      answer: "",
      answerRecord: [],
      exampleImages: [],
      testImages: [],
      loading: false,
    }
  },
  watch: {
    value: {
      handler(val) {
        this.answer = val;
      },
      immediate: true
    },
    subtopicInfo: {
      handler(val) {
        const refer = val.refer || [];
        const noise = val.noise || [];

        this.exampleImages = [...refer, ...refer, ...refer.map(() => {
          return { img_url: '', isOptional: true }
        })];
        this.testImages = this.shuffleArray([...refer, ...noise.map((item, index) => {
          return { ...item, index: refer.length + index };
        })]);
        if (this.originalSubtopicInfo.is_rec * 1 === 1) {
          this.answer = this.originalSubtopicInfo.rec_answer * 1;
          this.$emit('input', this.answer);
          this.$set(this, 'answerRecord', this.originalSubtopicInfo.rec_option);
          const emptyIndices = this.exampleImages.reduce((indices, item, index) => {
            if (item.isOptional) {
              indices.push(index);
            }
            return indices;
          }, []);
          this.answerRecord.forEach((recordItem, i) => {
            if (i < emptyIndices.length) {
              this.$set(this.exampleImages, emptyIndices[i], {
                ...recordItem
              });
            }
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    // 随机打乱数组
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    },
    flip() {
      this.flipStatus = !this.flipStatus
    },
    testSelect(item, testIndex) {
      if (this.loading) return;
      let flag = this.getSelectedStatus(item);
      if (flag) {
        this.loading = false;
        return;
      }
      const emptyIndex = this.exampleImages.findIndex(e => !e.img_url);
      if (emptyIndex === -1) {
        this.loading = false;
        return;
      }
      this.loading = true;
      const newItem = { ...this.exampleImages[emptyIndex], ...item };

      this.$nextTick(() => {
        const testElement = this.$el.querySelectorAll('.test .img-item')[testIndex];
        const exampleElement = this.$el.querySelectorAll('.example .img-item')[emptyIndex];

        this.startAnimation(testElement, exampleElement, item.img_url, () => {
          this.$set(this.exampleImages, emptyIndex, newItem);
          this.$set(this, 'answerRecord', this.exampleImages.filter(item => item.isOptional));
          this.loading = false;
          this.calculateAnswer();
        });
      });
    },
    exampleClick(item, index) {
      if (!item.isOptional || this.loading || !item.img_url) return;
      this.loading = true;
      const testIndex = this.testImages.findIndex(testItem => testItem.index * 1 === item.index * 1);
      if (testIndex === -1) return;
      const exampleElement = this.$el.querySelectorAll('.example .img-item')[index];
      const testElement = this.$el.querySelectorAll('.test .img-item')[testIndex];

      this.startAnimation(exampleElement, testElement, item.img_url, () => {
        this.$set(this.exampleImages, index, { img_url: '', isOptional: true });
        this.$set(this, 'answerRecord', this.exampleImages.filter(item => item.isOptional));
        this.loading = false;
        this.calculateAnswer();
      });
    },
    startAnimation(startEl, endEl, imgUrl, callback) {
      if (!startEl || !endEl) return;

      const container = endEl.closest('.image-container');
      const containerTransform = getComputedStyle(container).transform;
      const startRect = startEl.getBoundingClientRect();
      const endRect = endEl.getBoundingClientRect();

      // 创建克隆元素
      const clone = document.createElement('img');
      clone.src = imgUrl;
      clone.style.position = 'absolute';
      clone.style.left = `${startRect.left}px`;
      clone.style.top = `${startRect.top}px`;
      clone.style.width = `${startEl.offsetWidth}px`;
      clone.style.height = `${startEl.offsetHeight}px`;
      clone.style.borderRadius = '0.15rem';
      clone.style.objectFit = 'cover';
      clone.style.transition = 'all 0.5s ease';
      clone.style.zIndex = '1000';
      clone.style.transform = containerTransform;
      document.body.appendChild(clone);

      // 触发重绘
      void clone.offsetWidth;

      // 移动到目标位置
      clone.style.left = `${endRect.left}px`;
      clone.style.top = `${endRect.top}px`;

      // 动画结束后执行回调
      clone.addEventListener('transitionend', () => {
        clone.remove();
        if (callback) callback();
      });
    },
    getSelectedStatus(item) {
      return this.exampleImages.some(v => v.index * 1 === item.index * 1 && v.isOptional);
    },
    // 计算分数
    calculateAnswer() {
      let flag = this.answerRecord.every(v => !v.img_url);
      if (flag) {
        this.answer = '';
      } else {
        let correct = this.subtopicInfo.refer
        if (this.answerRecord.length === correct.length && this.answerRecord.every((v, i) => v.index * 1 === correct[i].index * 1)) {
          this.answer = 1;
        } else {
          this.answer = 0;
        }
      }
      this.$emit('input', this.answer);
    },
  },
}
</script>

<style lang="less" scoped>
.law {
  width: 100%;
  height: 100%;
  position: relative;
  .image-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    &.flip {
      transform: rotate(180deg);
    }
  }
  .img-list {
    width: 100%;
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
    margin: 0 auto;
    position: relative;
    .img-item {
      width: 0.9rem;
      height: 0.9rem;
      border-radius: 0.15rem;
      overflow: hidden;
      font-size: 0;
      margin: 0 0.05rem;
      &.isOptional{
        background: #fff;
        border: 1px solid #ffc2b0;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .test .selected img {
    display: none;
  }
  .flip-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 0.28rem;
    height: 0.28rem;
    font-size: 0;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>